import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 20,
};

export const certificatesListTableController = createSlice({
    name: 'certificatesListTableController',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const { changeCurrentPage } = certificatesListTableController.actions;

export default certificatesListTableController.reducer;